import React from "react";
import { Link } from "react-router-dom";
import MetaTags from "./MetaTags";
import "../css/BlogList.css";

const BlogDetails = ({ blog }) => {
  if (!blog)
    return (
      <div className="loading-container">
        <div className="loader"></div>
        <p>Loading blog details...</p>
      </div>
    );

  return (
    <>
      <MetaTags
        title={blog.meta_title || "Default Title"}
        description={blog.meta_description || "Default Description"}
        keywords={blog.meta_keywords || "Default Keywords"}
      />
      <div className="caseDetailsContainer">
        <div className="caseDetailsBack">
          <Link to="/blogs" className="back-button">
            <span className="back-icon-wrap">
              <svg
                className="back-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </span>
            <span>Back to Blogs</span>
          </Link>
        </div>
        <div className="caseDetailsHero">
          <div className="caseDetailsImageWrap">
            <img
              src={`http://admin.sixdindia.com/${blog.image}`}
              alt={blog.title}
              className="caseDetailsImage"
              loading="lazy"
            />
          </div>
          <h1 className="caseDetailsTitle font-face-futur-md-bt">{blog.title}</h1>
          <div className="caseDetailsMeta font-face-futur-LT">
            Published on: {new Date(blog.created_at).toLocaleDateString('en-IN', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
        <div
          className="caseDetailsContent font-face-futur-LT"
          dangerouslySetInnerHTML={{ __html: blog.description }}
        />
      </div>
    </>
  );
};

export default BlogDetails;